import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'components/Tooltip';
import { CFM_STONE } from 'constants/Colors';
import { t } from 'utils/getLiteral';

const PrincipalActionButton = ({ id, action = () => null, icon, label = '' }) => {
    const Icon = icon;

    const renderIcon = () => {
        if (typeof icon === 'string' || typeof icon === 'function') {
            return <Icon color={CFM_STONE} />;
        }
        if (typeof icon === 'object') {
            return icon;
        }
        return null;
    };

    return (
        <div className="action-buttons__principal">
            <Tooltip title={t(label)} position="top">
                <div role="button" tabIndex="-1" id={id} onClick={action}>
                    {renderIcon()}
                </div>
            </Tooltip>
        </div>
    );
};

PrincipalActionButton.propTypes = {
    id: PropTypes.string.isRequired,
    action: PropTypes.func,
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
    label: PropTypes.string,
};

export default PrincipalActionButton;
